<template>
  <v-card class="assignClient">

    <v-card-title style="height: 48px; flex-wrap: nowrap;">
      <v-layout row>
        <v-flex>
          <span class="roomName">Swap Client</span>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn xs icon flat @click.stop="handleCancel()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text>
      <div class="ntstSectionTitle">Swap</div>

      <v-layout row class="detailsRow">
        <v-flex>
          <div class="ntstValueLabel">Client</div>
          <div class="ntstValue">{{`${swapParams.fromValues.clientName.first} ${swapParams.fromValues.clientName.last}`}}</div>
        </v-flex>
      </v-layout>

      <v-layout row class="detailsRow">
        <v-flex xs6>
          <div class="ntstValueLabel">Room</div>
          <div class="ntstValue">{{swapParams.fromValues.roomName}}</div>
        </v-flex>
        <v-flex xs6>
          <div class="ntstValueLabel">Bed</div>
          <v-select style="width: 160px;" v-if="isEditable" :disabled="!isEditable" class="bedSelector ntstValue" :items="bedList(swapParams.fromValues)" v-model="swapParams.fromValues.bedID.id" item-value="bedBoardBedID.id" outline item-text="name"></v-select>
          <div v-if="!isEditable">{{ swapParams.fromValues.bedName }}</div>
        </v-flex>
      </v-layout>

      <div class="ntstSectionTitle">With</div>
      <v-layout row class="detailsRow">
        <v-flex>
          <div class="ntstValueLabel">Client</div>
          <div class="ntstValue">{{`${swapParams.withValues.clientName.first} ${swapParams.withValues.clientName.last}`}}</div>
        </v-flex>
      </v-layout>

      <v-layout row class="detailsRow">
        <v-flex xs6>
          <div class="ntstValueLabel">Room</div>
          <div class="ntstValue">{{swapParams.withValues.roomName}}</div>
        </v-flex>
        <v-flex xs6>
          <div class="ntstValueLabel">Bed</div>
          <v-select style="width: 160px;" v-if="isEditable" :disabled="!isEditable" class="bedSelector ntstValue" :items="bedList(swapParams.withValues)" v-model="swapParams.withValues.bedID.id" item-value="bedBoardBedID.id" outline item-text="name"></v-select>
          <div v-if="!isEditable">{{ swapParams.withValues.bedName }}</div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="ntstAppButton" @click.stop="handleCancel()">
        Cancel
      </v-btn>

      <v-btn class="ntstAppButton" @click.stop="handleSwap()">
        Swap
      </v-btn>
    </v-card-actions>
  </v-card>
</template>


<script lang="js">

export default {
  name: 'SwapConfirmation',
  data() {
    return {
      isEditable: true
    };
  },
  props: {
    onCancel: Function,
    onSwap: Function,
    swapParams: Object
  },
  components: {
  },
  computed: {
  },
  methods: {
    bedList(data) {
      let returnValue = [];

      if (data && data.beds) {
        returnValue = data.beds;
      }

      return returnValue;
    },

    handleCancel() {
      this.onCancel();
    },

    handleSwap() {
      this.onSwap(this.swapParams);
    },

  }
};
</script>

<style lang="scss">
.bedSelector {
  width: 280px;
}
.detailsRow {
  margin-bottom: 10px;
}
</style>
